import PropTypes from 'prop-types';
import { Breadcrumb as AntBreadcrumb, Dropdown } from 'antd';
import { FolderOutlined, EllipsisOutlined } from '@ant-design/icons';

import Styles from './Breadcrumb.module.css';

export const Breadcrumb = ({ currentPath, goToParent }) => {
  const displayMenu = currentPath.length > 3;

  const menuItems = currentPath
    .slice(1, currentPath.length - 2)
    .map((text, index) => ({
      key: text,
      label: (
        <div onClick={() => goToParent(index + 1)}>
          <FolderOutlined className={Styles.icon} />
          <span>{decodeURIComponent(text)}</span>
        </div>
      ),
    }));

  return (
    <AntBreadcrumb separator=">" className={Styles.breadcrumb}>
      {displayMenu ? (
        <>
          <AntBreadcrumb.Item onClick={() => goToParent(0)}>
            <FolderOutlined className={Styles.icon} />
            <span>{decodeURIComponent(currentPath[0])}</span>
          </AntBreadcrumb.Item>

          {/* Элемент с Dropdown */}
          <AntBreadcrumb.Item>
            <Dropdown
              menu={{ items: menuItems }}
              placement="bottomLeft"
              trigger={['click']}
            >
              <span>
                <EllipsisOutlined />
              </span>
            </Dropdown>
          </AntBreadcrumb.Item>

          <AntBreadcrumb.Item
            onClick={() => goToParent(currentPath.length - 2)}
          >
            <FolderOutlined className={Styles.icon} />
            <span>
              {decodeURIComponent(currentPath[currentPath.length - 2])}
            </span>
          </AntBreadcrumb.Item>

          <AntBreadcrumb.Item
            onClick={() => goToParent(currentPath.length - 1)}
          >
            <FolderOutlined className={Styles.icon} />
            <span>
              {decodeURIComponent(currentPath[currentPath.length - 1])}
            </span>
          </AntBreadcrumb.Item>
        </>
      ) : (
        currentPath.map((text, index) => (
          <AntBreadcrumb.Item key={text} onClick={() => goToParent(index)}>
            <FolderOutlined className={Styles.icon} />
            <span>{decodeURIComponent(text)}</span>
          </AntBreadcrumb.Item>
        ))
      )}
    </AntBreadcrumb>
  );
};

Breadcrumb.propTypes = {
  currentPath: PropTypes.arrayOf(PropTypes.string),
  goToParent: PropTypes.func,
};
